/* tslint:disable */
/* eslint-disable */
/**
 * Jen API
 * Jen RESTful APIs, designed to provide easy access to our latest music generation models.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EditMusicDto,
  GenerateMusicV2Dto,
  ReimagineMusicV2Dto,
} from '../models/index';
import {
    EditMusicDtoFromJSON,
    EditMusicDtoToJSON,
    GenerateMusicV2DtoFromJSON,
    GenerateMusicV2DtoToJSON,
    ReimagineMusicV2DtoFromJSON,
    ReimagineMusicV2DtoToJSON,
} from '../models/index';

export interface AudioControllerV2AudilDetailRequest {
    id: string;
}

export interface AudioControllerV2CheckexistRequest {
    id: string;
}

export interface AudioControllerV2DownloadRequest {
    id: string;
}

export interface AudioControllerV2DownloadFolderRequest {
    folderId: number;
}

export interface AudioControllerV2DownloadStemsRequest {
    id: string;
}

export interface AudioControllerV2EditRequest {
    editMusicDto?: EditMusicDto;
}

export interface AudioControllerV2GenerateRequest {
    generateMusicV2Dto?: GenerateMusicV2Dto;
}

export interface AudioControllerV2GenerationDemucsCompletedRequest {
    callbackToken: string;
    id: string;
    timeConsuming: string;
}

export interface AudioControllerV2GenerationDemucsErrorRequest {
    callbackToken: string;
    id: string;
    message: string;
}

export interface AudioControllerV2GenerationDemucsStartRequest {
    callbackToken: string;
    id: string;
}

export interface AudioControllerV2GetAllTracksPublicRequest {
    page: number;
    pageSize: number;
    sortOrder: string;
    name: string;
    id: string;
    queryType: string;
    stylefilter: string;
}

export interface AudioControllerV2GetAllTracksV2Request {
    page: number;
    pageSize: number;
    sortOrder: string;
    name: string;
    folderId: number;
    id: string;
    queryType: string;
    stylefilter: string;
}

export interface AudioControllerV2GetPeaksRequest {
    audioId: string;
}

export interface AudioControllerV2M3u8MockRequest {
    id: string;
}

export interface AudioControllerV2PrivateSharingAudilDetailRequest {
    id: string;
}

export interface AudioControllerV2ReimagineRequest {
    reimagineMusicV2Dto?: ReimagineMusicV2Dto;
}

export interface AudioControllerV2UploadAudioForTrimRequest {
    file?: Blob;
    audioId?: string;
    startTime?: number;
    endTime?: number;
}

/**
 * 
 */
export class AudioApi extends runtime.BaseAPI {

    /**
     */
    async audioControllerV2AudilDetailRaw(requestParameters: AudioControllerV2AudilDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling audioControllerV2AudilDetail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT-auth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/audio/detail/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async audioControllerV2AudilDetail(requestParameters: AudioControllerV2AudilDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.audioControllerV2AudilDetailRaw(requestParameters, initOverrides);
    }

    /**
     */
    async audioControllerV2CheckexistRaw(requestParameters: AudioControllerV2CheckexistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling audioControllerV2Checkexist().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT-auth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/audio/generation_status/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async audioControllerV2Checkexist(requestParameters: AudioControllerV2CheckexistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.audioControllerV2CheckexistRaw(requestParameters, initOverrides);
    }

    /**
     */
    async audioControllerV2DownloadRaw(requestParameters: AudioControllerV2DownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling audioControllerV2Download().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT-auth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/audio/download/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async audioControllerV2Download(requestParameters: AudioControllerV2DownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.audioControllerV2DownloadRaw(requestParameters, initOverrides);
    }

    /**
     */
    async audioControllerV2DownloadFolderRaw(requestParameters: AudioControllerV2DownloadFolderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['folderId'] == null) {
            throw new runtime.RequiredError(
                'folderId',
                'Required parameter "folderId" was null or undefined when calling audioControllerV2DownloadFolder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT-auth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/audio/download_folder/{folder_id}`.replace(`{${"folder_id"}}`, encodeURIComponent(String(requestParameters['folderId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async audioControllerV2DownloadFolder(requestParameters: AudioControllerV2DownloadFolderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.audioControllerV2DownloadFolderRaw(requestParameters, initOverrides);
    }

    /**
     */
    async audioControllerV2DownloadStemsRaw(requestParameters: AudioControllerV2DownloadStemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling audioControllerV2DownloadStems().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT-auth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/audio/download_stems/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async audioControllerV2DownloadStems(requestParameters: AudioControllerV2DownloadStemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.audioControllerV2DownloadStemsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async audioControllerV2EditRaw(requestParameters: AudioControllerV2EditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT-auth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/audio/edit`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EditMusicDtoToJSON(requestParameters['editMusicDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async audioControllerV2Edit(requestParameters: AudioControllerV2EditRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.audioControllerV2EditRaw(requestParameters, initOverrides);
    }

    /**
     */
    async audioControllerV2GenerateRaw(requestParameters: AudioControllerV2GenerateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT-auth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/audio/generate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GenerateMusicV2DtoToJSON(requestParameters['generateMusicV2Dto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async audioControllerV2Generate(requestParameters: AudioControllerV2GenerateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.audioControllerV2GenerateRaw(requestParameters, initOverrides);
    }

    /**
     */
    async audioControllerV2GenerationDemucsCompletedRaw(requestParameters: AudioControllerV2GenerationDemucsCompletedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['callbackToken'] == null) {
            throw new runtime.RequiredError(
                'callbackToken',
                'Required parameter "callbackToken" was null or undefined when calling audioControllerV2GenerationDemucsCompleted().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling audioControllerV2GenerationDemucsCompleted().'
            );
        }

        if (requestParameters['timeConsuming'] == null) {
            throw new runtime.RequiredError(
                'timeConsuming',
                'Required parameter "timeConsuming" was null or undefined when calling audioControllerV2GenerationDemucsCompleted().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v2/audio/stem_splitting_complete/{callback_token}/{id}/{time_consuming}`.replace(`{${"callback_token"}}`, encodeURIComponent(String(requestParameters['callbackToken']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"time_consuming"}}`, encodeURIComponent(String(requestParameters['timeConsuming']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async audioControllerV2GenerationDemucsCompleted(requestParameters: AudioControllerV2GenerationDemucsCompletedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.audioControllerV2GenerationDemucsCompletedRaw(requestParameters, initOverrides);
    }

    /**
     */
    async audioControllerV2GenerationDemucsErrorRaw(requestParameters: AudioControllerV2GenerationDemucsErrorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['callbackToken'] == null) {
            throw new runtime.RequiredError(
                'callbackToken',
                'Required parameter "callbackToken" was null or undefined when calling audioControllerV2GenerationDemucsError().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling audioControllerV2GenerationDemucsError().'
            );
        }

        if (requestParameters['message'] == null) {
            throw new runtime.RequiredError(
                'message',
                'Required parameter "message" was null or undefined when calling audioControllerV2GenerationDemucsError().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v2/audio/generation_demucs_error/{callback_token}/{id}/{message}`.replace(`{${"callback_token"}}`, encodeURIComponent(String(requestParameters['callbackToken']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"message"}}`, encodeURIComponent(String(requestParameters['message']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async audioControllerV2GenerationDemucsError(requestParameters: AudioControllerV2GenerationDemucsErrorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.audioControllerV2GenerationDemucsErrorRaw(requestParameters, initOverrides);
    }

    /**
     */
    async audioControllerV2GenerationDemucsStartRaw(requestParameters: AudioControllerV2GenerationDemucsStartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['callbackToken'] == null) {
            throw new runtime.RequiredError(
                'callbackToken',
                'Required parameter "callbackToken" was null or undefined when calling audioControllerV2GenerationDemucsStart().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling audioControllerV2GenerationDemucsStart().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v2/audio/generation_demucs_start/{callback_token}/{id}`.replace(`{${"callback_token"}}`, encodeURIComponent(String(requestParameters['callbackToken']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async audioControllerV2GenerationDemucsStart(requestParameters: AudioControllerV2GenerationDemucsStartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.audioControllerV2GenerationDemucsStartRaw(requestParameters, initOverrides);
    }

    /**
     */
    async audioControllerV2GetAllTracksPublicRaw(requestParameters: AudioControllerV2GetAllTracksPublicRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling audioControllerV2GetAllTracksPublic().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling audioControllerV2GetAllTracksPublic().'
            );
        }

        if (requestParameters['sortOrder'] == null) {
            throw new runtime.RequiredError(
                'sortOrder',
                'Required parameter "sortOrder" was null or undefined when calling audioControllerV2GetAllTracksPublic().'
            );
        }

        if (requestParameters['name'] == null) {
            throw new runtime.RequiredError(
                'name',
                'Required parameter "name" was null or undefined when calling audioControllerV2GetAllTracksPublic().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling audioControllerV2GetAllTracksPublic().'
            );
        }

        if (requestParameters['queryType'] == null) {
            throw new runtime.RequiredError(
                'queryType',
                'Required parameter "queryType" was null or undefined when calling audioControllerV2GetAllTracksPublic().'
            );
        }

        if (requestParameters['stylefilter'] == null) {
            throw new runtime.RequiredError(
                'stylefilter',
                'Required parameter "stylefilter" was null or undefined when calling audioControllerV2GetAllTracksPublic().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['queryType'] != null) {
            queryParameters['queryType'] = requestParameters['queryType'];
        }

        if (requestParameters['stylefilter'] != null) {
            queryParameters['stylefilter'] = requestParameters['stylefilter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT-auth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/audio/all_tracks_public`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async audioControllerV2GetAllTracksPublic(requestParameters: AudioControllerV2GetAllTracksPublicRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.audioControllerV2GetAllTracksPublicRaw(requestParameters, initOverrides);
    }

    /**
     */
    async audioControllerV2GetAllTracksV2Raw(requestParameters: AudioControllerV2GetAllTracksV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling audioControllerV2GetAllTracksV2().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling audioControllerV2GetAllTracksV2().'
            );
        }

        if (requestParameters['sortOrder'] == null) {
            throw new runtime.RequiredError(
                'sortOrder',
                'Required parameter "sortOrder" was null or undefined when calling audioControllerV2GetAllTracksV2().'
            );
        }

        if (requestParameters['name'] == null) {
            throw new runtime.RequiredError(
                'name',
                'Required parameter "name" was null or undefined when calling audioControllerV2GetAllTracksV2().'
            );
        }

        if (requestParameters['folderId'] == null) {
            throw new runtime.RequiredError(
                'folderId',
                'Required parameter "folderId" was null or undefined when calling audioControllerV2GetAllTracksV2().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling audioControllerV2GetAllTracksV2().'
            );
        }

        if (requestParameters['queryType'] == null) {
            throw new runtime.RequiredError(
                'queryType',
                'Required parameter "queryType" was null or undefined when calling audioControllerV2GetAllTracksV2().'
            );
        }

        if (requestParameters['stylefilter'] == null) {
            throw new runtime.RequiredError(
                'stylefilter',
                'Required parameter "stylefilter" was null or undefined when calling audioControllerV2GetAllTracksV2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['folderId'] != null) {
            queryParameters['folderId'] = requestParameters['folderId'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['queryType'] != null) {
            queryParameters['queryType'] = requestParameters['queryType'];
        }

        if (requestParameters['stylefilter'] != null) {
            queryParameters['stylefilter'] = requestParameters['stylefilter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT-auth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/audio/all_tracks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async audioControllerV2GetAllTracksV2(requestParameters: AudioControllerV2GetAllTracksV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.audioControllerV2GetAllTracksV2Raw(requestParameters, initOverrides);
    }

    /**
     */
    async audioControllerV2GetCatalogOverviewRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT-auth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/audio/catalog_overview`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async audioControllerV2GetCatalogOverview(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.audioControllerV2GetCatalogOverviewRaw(initOverrides);
    }

    /**
     */
    async audioControllerV2GetPeaksRaw(requestParameters: AudioControllerV2GetPeaksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['audioId'] == null) {
            throw new runtime.RequiredError(
                'audioId',
                'Required parameter "audioId" was null or undefined when calling audioControllerV2GetPeaks().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT-auth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/audio/peaks/{audioId}`.replace(`{${"audioId"}}`, encodeURIComponent(String(requestParameters['audioId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async audioControllerV2GetPeaks(requestParameters: AudioControllerV2GetPeaksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.audioControllerV2GetPeaksRaw(requestParameters, initOverrides);
    }

    /**
     */
    async audioControllerV2M3u8MockRaw(requestParameters: AudioControllerV2M3u8MockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling audioControllerV2M3u8Mock().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v2/audio/{id}.m3u8`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async audioControllerV2M3u8Mock(requestParameters: AudioControllerV2M3u8MockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.audioControllerV2M3u8MockRaw(requestParameters, initOverrides);
    }

    /**
     */
    async audioControllerV2PrivateSharingAudilDetailRaw(requestParameters: AudioControllerV2PrivateSharingAudilDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling audioControllerV2PrivateSharingAudilDetail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT-auth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/audio/private_sharing_detail/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async audioControllerV2PrivateSharingAudilDetail(requestParameters: AudioControllerV2PrivateSharingAudilDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.audioControllerV2PrivateSharingAudilDetailRaw(requestParameters, initOverrides);
    }

    /**
     */
    async audioControllerV2ReimagineRaw(requestParameters: AudioControllerV2ReimagineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT-auth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/audio/reimagine`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReimagineMusicV2DtoToJSON(requestParameters['reimagineMusicV2Dto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async audioControllerV2Reimagine(requestParameters: AudioControllerV2ReimagineRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.audioControllerV2ReimagineRaw(requestParameters, initOverrides);
    }

    /**
     */
    async audioControllerV2UploadAudioForAcrRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v2/audio/upload_audio_for_acr`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async audioControllerV2UploadAudioForAcr(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.audioControllerV2UploadAudioForAcrRaw(initOverrides);
    }

    /**
     */
    async audioControllerV2UploadAudioForTrimRaw(requestParameters: AudioControllerV2UploadAudioForTrimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        if (requestParameters['audioId'] != null) {
            formParams.append('audioId', requestParameters['audioId'] as any);
        }

        if (requestParameters['startTime'] != null) {
            formParams.append('startTime', requestParameters['startTime'] as any);
        }

        if (requestParameters['endTime'] != null) {
            formParams.append('endTime', requestParameters['endTime'] as any);
        }

        const response = await this.request({
            path: `/api/v2/audio/upload_audio_for_trim`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async audioControllerV2UploadAudioForTrim(requestParameters: AudioControllerV2UploadAudioForTrimRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.audioControllerV2UploadAudioForTrimRaw(requestParameters, initOverrides);
    }

}
